'use client'
import axios, { AxiosResponse } from "axios"
import { ILogin, IPaginationOptions } from "./types";
import { BASE_URL } from "./constants";
export class ApiClient {
   ACCESS_TOKEN : string | null = null;
    constructor(accessToken?:string){
        if(accessToken) this.ACCESS_TOKEN = accessToken
    }
    get =async (endpoint: string): Promise<AxiosResponse> =>{
        var config: any = {
            'Content-type':'application/json'
        }
        if(this.ACCESS_TOKEN && this.ACCESS_TOKEN != ''){
            config.authorization = `Bearer ${this.ACCESS_TOKEN}`;
        }
        const response = await axios.get(`${BASE_URL}${endpoint}`,{headers:{config}});
        return response;
    }


    post =async (endpoint: string,data:any, options?:any): Promise<AxiosResponse> =>{
        var config: any = {
            'Content-type':'application/json'
        }
        if(this.ACCESS_TOKEN && this.ACCESS_TOKEN != ''){
            config.authorization = `Bearer ${this.ACCESS_TOKEN}`;
        }
        const response = await axios.post(`${BASE_URL}${endpoint}`,data,{headers:{config}});
        return response;
    }

    login = async (path:string,body:ILogin):Promise<AxiosResponse> =>{
        const login = await this.post(path,body);
        return login;
    }

    getMenuActions = async (position: number) : Promise<AxiosResponse> =>{
        const actions = await this.get(`/actions/${position}`);
        return actions;
    }

    getActiveUsers =async ()=>{
        const users = await this.get(`/active-users`);
        return users;
    }
    getUsers =async (options?: IPaginationOptions)=>{
        const page = options && options.page ? options.page : 1;
        const take = options && options.take ? options.take : 20;
        const users = await this.get(`/users?page=${page}&take=${take}`);
        return users;
    }
    getVehicles =async ()=>{
        const vehicles = await this.get(`/vehicles`);
        return vehicles;
    }

    getTrips = async (options?: IPaginationOptions)=>{
        const page = options && options.page || 1;
        const take = options && options.take || 20
        const trips = await this.get(`/trips?page=${page}&take=${take}`);
        return trips;
    }
    getNotifications = async (userId:number, options?: IPaginationOptions)=>{
        const page = options && options.page || 1;
        const take = options && options.take || 20
        const notifications = await this.get(`/notifications/${userId}?page=${page}&take=${take}`);
        return notifications;
    }
    getRequests =async (options?: IPaginationOptions)=>{
        const page = options && options.page || 1;
        const take = options && options.take || 20
        const requests = await this.get(`/requests?page=${page}&take=${take}`);
        return requests;
    }
    getRequestDetails =async (requestId:number,requestType:number)=>{
        const request = await this.get(`/request/${requestId}/${requestType}`);
        return request;
    }
    getAllProjects = async ()=>{
        const projects = await this.get(`/projects`);
        return projects;
    }
    getActiveFundcodes = async () =>{
        const fundcodes = await this.get(`/fundcodes`);
        return fundcodes;
    }
    getLastRequestOnVehicle =async (vehicle:string, request_type: number) => {
        const axios = await this.get(`/last_request/${vehicle}?type=${request_type}`)
        return axios;
      }
}